export default __webpack_public_path__ + "7a873ed18760f98aee38dfe3db7550b9.svg";